import React from "react";
import { useForm } from "react-final-form";
import {
  InstrumentTypeSelectField,
  MaterialColorSelectField,
  MouthpieceDesignSelectField,
  MouthpieceDesignFontSelectField,
} from "@syos-music/instruments";
import {
  TextField,
  RadioGroupField,
  SelectField,
  SliderField,
  SwitchField,
  Fieldset,
} from "@syos-music/form";

import { Grid, MenuItem, Typography } from "@mui/material";

export default function OptionsFields({ isOrderPaid, name }) {
  const form = useForm();

  const clarinetType = form.getFieldState(`${name}.clarinetType`)?.value;
  const useDesign = form.getFieldState(`${name}.useDesign`)?.value;
  const designType = form.getFieldState(`${name}.designType`)?.value;

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <InstrumentTypeSelectField
          instrument="clarinet"
          name={`${name}.clarinetType`}
          required
        />
      </Grid>

      <Grid item xs={12}>
        <SelectField name={`${name}.level`} label="Niveau">
          <MenuItem value="beginner">Débutant</MenuItem>
          <MenuItem value="intermediate">Intermédiaire</MenuItem>
          <MenuItem value="professional">Professionnel</MenuItem>
        </SelectField>
      </Grid>

      <Grid item xs={12}>
        <TextField
          name={`${name}.musicStyles`}
          label="Styles musicaux"
          parse={(value) => value.split(",")}
          format={(value) => (value || []).join(",")}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SliderField
          name={`${name}.brightness`}
          label="Brillance"
          min={0}
          max={10}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SliderField name={`${name}.power`} label="Puisance" min={0} max={10} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name={`${name}.brand`} label="Marque du bec actuel" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name={`${name}.model`} label="Modèle du bec actuel" />
      </Grid>

      <Grid item xs={12}>
        <TextField
          name={`${name}.qualitiesAndImprovements`}
          label="Qualités et améliorations"
          multiline
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name={`${name}.reedsBrand`} label="Marque d’anches" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name={`${name}.reedsStrength`} label="Force d’anches" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField
          name={`${name}.mouthpieceColor`}
          allowPrivate
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField name={`${name}.ligatureColor`} allowPrivate />
      </Grid>

      <Grid item xs={12}>
        <Fieldset legend="Design">
          <Grid container>
            <Grid item xs={12} sm={6}>
              <SwitchField
                name={`${name}.useDesign`}
                disabled={isOrderPaid}
                label="Utiliser un design ?"
                fullWidth
              />
            </Grid>

            {!!useDesign && (
              <>
                <Grid item xs={12} sm={6}>
                  <RadioGroupField
                    name={`${name}.designType`}
                    disabled={isOrderPaid}
                    label="Type de design"
                    required
                    fullWidth
                  >
                    <RadioGroupField.Option value="syos" label="Syos" />
                    <RadioGroupField.Option value="text" label="Texte" />
                    <RadioGroupField.Option value="image" label="Image" />
                  </RadioGroupField>
                </Grid>

                {designType === "syos" && (
                  <Grid item xs={12}>
                    <MouthpieceDesignSelectField
                      name={`${name}.mouthpieceDesign`}
                      required
                    />
                  </Grid>
                )}

                {designType === "text" && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <MouthpieceDesignFontSelectField
                        name={`${name}.designTextFont`}
                        required
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        name={`${name}.designText`}
                        label="Design text"
                        fullWidth
                        required
                        inputProps={{
                          maxLength: {
                            bFlat: 15,
                            bass: 15,
                          }[clarinetType],
                        }}
                      />
                    </Grid>
                  </>
                )}

                {designType === "image" && (
                  <Grid item xs={12}>
                    <Typography
                      color={isOrderPaid ? "textSecondary" : "textPrimary"}
                    >
                      Les images des design ne sont pas modifiables.
                    </Typography>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Fieldset>
      </Grid>

      <Grid item xs={12}>
        <TextField name={`${name}.comment`} multiline label="Commentaire" />
      </Grid>
    </Grid>
  );
}
